export default {
  namespaced: true,
  getters: {
    elements: (state, getters, rootState, rootGetters) => element => {
      let rows = rootGetters['sectionModule/elements'](element).rows
      return Object.prototype.hasOwnProperty.call(element, 'row') ? rows[element.row] : rows
    },
    name: (state, getters) => element => getters.elements(element).name,
    id: (state, getters) => element =>  getters.elements(element).id,
    index: (state, getters) => (element, id) => getters.elements(element).findIndex(row => row.id == id),
    classes: (state, getters) => (element, classes = 'classes') => getters.elements(element)[classes],
    styles: (state, getters) => (element, styles = 'styles') => getters.elements(element)[styles],
    assets: (state, getters) => element => getters.elements(element).assets,
    properties: (state, getters) => element => getters.elements(element).properties,
    background: (state, getters) => element => getters.elements(element).background,
  },
  actions: {
    updateOrder({commit}, payload) {
      payload = {...payload, module: 'rowModule'}
      commit('actionsModule/updateElementsOrder', payload, {root: true})
    },
    addToArray({commit}, payload) {
      payload = {...payload, module: 'rowModule'}
      commit('actionsModule/addToArray', payload, {root: true})
    },
    addToObject({commit}, payload) {
      payload = {...payload, module: 'rowModule'}
      commit('actionsModule/addToObject', payload, {root: true})
    },
    removeFromArray({commit}, payload) {
      payload = {...payload, module: 'rowModule'}
      commit('actionsModule/removeFromArray', payload, {root: true})
    },
  }
}